module.exports = __webpack_public_path__ + "static/libraryflix-logo-2b0c8e3bb58fa63764a61c9bb942d4a2.png";